import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-login-to-airtel',
  standalone: true,
  imports: [CommonModule, ButtonModule, PasswordModule, FormsModule],
  templateUrl: './login-to-airtel.component.html',
  styleUrl: './login-to-airtel.component.scss'
})
export class LoginToAirtelComponent {
  /** Configure Airtel login URL via environment or leave empty to open in new tab when provided */
  showAirtelPassword = false;
  showZohoPassword = false
  airtelLoginUrl = 'https://www.airtel.in/business/b2b/airtel-iq/dashboard/#/';
  airtelUsername = 'admin@gradpilots.com';
  airtelPassword = 'Airtel@2025';
  zohoLoginUrl = 'https://home.zoho.in/home';
  zohoUsername = 'support@gradpilots.com';
  zohoPassword = 'Support@GP1605!!';

  maskPassword(value: string): string {
  return value ? '*'.repeat(value.length) : '';
  }
  openAirtelLogin(): void {
    const url = this.airtelLoginUrl || 'https://www.airtel.in/business/b2b/airtel-iq/dashboard/#/';
    window.open(url, '_blank');
  }
  openZohoLogin(): void {
    const url = this.zohoLoginUrl || 'https://home.zoho.in/home';
    window.open(url, '_blank');
  }
}
